// Audio + haptic feedback helpers for QR scans.
//
// No asset files: tones are synthesised via Web Audio so we have full control
// over duration/pitch and pay zero bundle cost. The AudioContext is created
// lazily on first use (and resumed after user gesture, per Chrome autoplay
// policy). If anything fails — old browser, blocked autoplay, no vibration
// API — every helper degrades silently.

let audioCtx = null;

const getAudioCtx = () => {
  if (audioCtx) return audioCtx;
  try {
    const Ctor = window.AudioContext || window.webkitAudioContext;
    if (!Ctor) return null;
    audioCtx = new Ctor();
    return audioCtx;
  } catch (_) {
    return null;
  }
};

const playTone = (frequency, durationMs, type = 'sine', volume = 0.15) => {
  const ctx = getAudioCtx();
  if (!ctx) return;
  // Some browsers suspend the context until a user gesture; the modal opens
  // from a button click, so resume() is normally fine.
  if (ctx.state === 'suspended') {
    ctx.resume().catch(() => {});
  }
  try {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = type;
    osc.frequency.value = frequency;
    gain.gain.value = volume;
    osc.connect(gain);
    gain.connect(ctx.destination);
    const now = ctx.currentTime;
    osc.start(now);
    // Short fade-out so we don't get a click at the end
    gain.gain.setValueAtTime(volume, now + durationMs / 1000 - 0.02);
    gain.gain.linearRampToValueAtTime(0, now + durationMs / 1000);
    osc.stop(now + durationMs / 1000);
  } catch (_) {
    /* swallow — audio is non-critical */
  }
};

const vibrate = (ms) => {
  try {
    if (typeof navigator !== 'undefined' && navigator.vibrate) {
      navigator.vibrate(ms);
    }
  } catch (_) {
    /* not supported, ignore */
  }
};

export const playSuccessFeedback = (muted) => {
  if (!muted) playTone(880, 120, 'sine', 0.18);
  vibrate(40);
};

export const playErrorFeedback = (muted) => {
  if (!muted) {
    playTone(220, 180, 'square', 0.12);
    setTimeout(() => playTone(180, 180, 'square', 0.12), 200);
  }
  vibrate([60, 40, 60]);
};

export const playDuplicateFeedback = (muted) => {
  if (!muted) playTone(440, 80, 'sine', 0.1);
  vibrate(20);
};
